<fq-video-player [configuration]="videoPlayerConfiguration" [data]="videoPlayerdata"></fq-video-player>
